<template>
  <v-container fluid class="invoice-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-space-between justify-md-start overflow-auto">
              <v-btn @click="addItem" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindInvoice=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makeDepositList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Deposit
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_invoices.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="invoices-table"
              sort-by="invoicenum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_invoice"
              :items="data_invoices"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Invoice?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_invoice.invoicenum }} 
                      {{ delete_invoice.invoicename }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_invoice)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>                    
                  </p>
                </div>
              </template>
              <template v-slot:item.invoiceimage="{ item }">
                    <v-img
                    v-if="item.invoiceimage" 
                    v-bind:src="item.invoiceimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.invoicenum="{ item }">
                
                <p class="two-line">{{ item.invoicetype  }}</p>
                <p class="two-line">{{ item.invoicenum  }}</p>
                <p v-if="item.invoicedate!=undefined" class="two-line">{{ new Date(item.invoicedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.invoicename="{ item }">
                <p class="two-line">{{ item.invoicename }}</p>
                <p class="two-line">{{ item.invoiceaddress }}</p>
                <p v-if="item.regionid!=undefined && item.townshipid!=undefined" class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }} - {{ item.customertype }}</p>
              </template>
              <template v-slot:item.deposits="{ item }">
                <div v-if="item.deposits">{{ item.deposits.map(item=>item.transamount.toString()).join(', ') }}</div>
                <div v-if="item.deposits" style="font-size: 8pt;">{{ item.deposits.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })).join(', ') }}</div>
              </template>
              <template v-slot:item.invoicetotal="{ item }">
                <p class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.invoicetotal.toLocaleString('en-SG') }}</p>
                <p v-if="item.primaryCurrency!=item.secondaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.secondaryCurrency }}</span> {{ (item.invoicetotal * item.currencyRate).toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.invoicestatus="{ item }">
                <v-chip
                  v-if="item.invoicestatus!=undefined"
                  :color="getStatusColor(item.invoicestatus)" small>
                  {{ item.invoicestatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.invoicestatus=='New'" icon color="primary" @click="updateInvoiceSendDialog(item)">
                  <v-icon>mdi-text-box-edit</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.invoicestatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isFindInvoice"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Invoices</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                     outlined
                     dense
                     v-model="find_query.enddate"
                     label="End Date"
                     v-bind="attrs"
                     v-bind:value="find_query.enddate"
                     v-on="on"
                     persistent-hint
                    single-line hint="Please enter end date">
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="find_query.enddate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu_enddate = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu_enddate.save(find_query.enddate)"
                  >
                    OK
                  </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindInvoice = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetInvoices"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findInvoices"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isInvoiceSend"
      persistent
      width="400px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Send Invoice</span>
        </v-card-title>
        <v-card-text>
          {{ send_invoice.invoicetype }} {{ send_invoice.invoicenum }}
        </v-card-text>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="send_invoice.confirm"
                  required
                  dense
                  persistent-hint
                  single-line hint="Type the word 'Send'"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isInvoiceSend=false; send_invoice={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="send_invoice.confirm!=='Send'"
            @click="updateInvoiceSend"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'InvoiceList',
  props: {
    type: String
  },
  data() {
    return {
      config,
      header_invoice: [
        { text: 'Invoice', value: 'invoicenum', sortable: false },
        { text: 'Name', value: 'invoicename' },
        { text: 'Amount', value: 'invoicetotal', width: "10%" },
        { text: 'Received', value: 'deposits', width: "8%" },
        { text: 'Create By', value: 'userid', width: "10%" },
        { text: 'Status', value: 'invoicestatus', width: "8%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindInvoice: false,
      isInvoiceSend: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_invoice: {},
      send_invoice: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      data_invoices: [],
      data_selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Invoice', ['invoices', 'query', 'isReceiving', 'isDeleting',]),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Invoice', ["getInvoicesRequest", "findInvoicesRequest", "deleteInvoiceRequest","updateInvoiceRequest","updateInvoiceSendRequest","setQuery"]),
    ...mapActions('PayMethod', ["getPayMethodsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_invoices.map(order=>{return {
        ordernum: order.invoicenum, 
        orderdate: order.invoicedate!=undefined ? new Date(order.invoicedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.invoicedate!=undefined ? new Date(order.invoicedate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.invoicetype,
        name: order.invoicename, 
        address: order.invoiceaddress,
        region: order.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        township: order.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == order.townshipid)['townshipname'] : '',
        customertype: order.customertype,
        rep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.invoicetaxamount,
        subtotal: order.invoicesubtotal,
        total: order.invoicetotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.invoicestatus=='Completed')!=null) return false;
      return true;
    },
    checkInvoices(){
      return this.data_selected.filter(item=>item.invoicestatus=='Completed').map(item=>item.invoicenum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    makeDepositList(){
      if(!this.checkError()) {
        if(this.data_selected.length==0) this.dialogMessage='No Invoices selected';
        else this.dialogMessage='The following Invoices cannot be deposited:  ' + this.checkInvoices();
        this.dialogAlert=true; 
        return;
      }
      let orders = Object.assign([], this.data_selected);
      let json = {orders: orders, isInvoices: true};
      this.$router.push({ name: 'BatchDepositAdd', params: json });
    },
    addItem() {
      if(this.data_selected.length==0) this.$router.push({ name: 'InvoiceAdd' });
      else {
        let item = Object.assign({}, this.data_selected[0]);
        delete item['_id'];
        delete item['key'];
        delete item['createdAt'];
        delete item['updatedAt'];

        this.$router.push({ name: 'InvoiceAdd', params: item });
      }
    },
    editItem(item) {
      this.$router.push({ name: 'InvoiceEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'InvoicePrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InvoiceView', params: item });
    },
    async findInvoices(){
      this.isFindInvoice = false;
      if(Object.keys(this.find_query).length==0){
        await this.getInvoicesRequest();
        this.data_invoices = Object.assign([], this.invoices);
        this.data_invoices.push({invoicetotal: this.invoices.reduce(function (last, json) {return last + json.invoicetotal;}, 0) });
      }
      else{
        let result = await this.findInvoicesRequest(this.find_query);
        this.data_invoices = Object.assign([], result);
        this.data_invoices.push({invoicetotal: result.reduce(function (last, json) {return last + json.invoicetotal;}, 0) });
      }
    },
    async resetInvoices(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteInvoiceRequest({_id: item._id});
      this.data_invoices = this.invoices;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_invoice = { _id: item._id, invoicenum: item.invoicenum, invoicename: item.invoicename };
    },
    updateInvoiceSendDialog(item) {
      this.isInvoiceSend = true;
      this.send_invoice = { _id: item._id, invoicenum: item.invoicenum, invoicetype: item.invoicetype };
    },
    async updateInvoiceSend() {
      this.isInvoiceSend = false;
      let result = await this.updateInvoiceSendRequest(this.send_invoice);
      let index = this.data_invoices.findIndex((x) => x._id == result._id);
      this.data_invoices.splice(index, 1, result);
      this.send_invoice = {};
    },
  },
  async created () {
    if(this.$route.params.isDeposit==true) this.data_selected = this.$route.params.orders;
    if(this.query==null || Object.keys(this.query).length==0){
      await this.getInvoicesRequest();
      this.data_invoices = Object.assign([], this.invoices);
    }
    else {
      this.find_query = Object.assign({}, this.query)
      let result = await this.findInvoicesRequest(this.query);
      this.data_invoices = Object.assign([], result);
    }

    //if(this.paymethods.length==0) await this.getPayMethodsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    //if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
